export const isDayOfWeekPreset = dayValue => {
  return dayValue === 'WEEKDAY' || dayValue === 'EVERY_DAY' || dayValue === 'WEEKEND';
};